import React, { useState } from 'react';
import MakeATabView from '../hunt-planner/reusableComponents/tabView/tabView';
import { connect } from 'react-redux'
import './index.scss'
import { selectedTabAction } from '../../action/selected-tab-action';
import { expandMorefilterMenu } from '../../action/huntplanner-morefilters-actions';
import { huntPlannerRightMenuBarHide } from '../../action/huntplanner-menu-bar';
import ReusableButton from '../hunt-planner/reusableComponents/button/customButton';
import { multiTileHuntLayersXYZ, multiTileHuntLayersXYZTwoLayers } from '../hunt-planner/huntplanner-layer-render/renderlayerFunction';

const TopMenu = (props) => {
    const [selectedTab, setSelectedTab] = useState(props.selectedTabvalue);
    const [xyz, setXYZ] = useState(false)
    const [xYZDouble, setXYZDouble] = useState(false)

    const handleTabChange = (tab, label) => {
        setSelectedTab(tab);
        props.selectedTabAction(tab)
        if (tab == 'map') {
            props.expandMorefilterMenu(false)
            props.huntPlannerRightMenuBarHide()
        }
        console.log(`Tab changed to: ${label}`);
    };

    const tabs = [
        { tab: 'map', label: 'Map' },
        { tab: 'huntplanner', label: 'Hunt Planner' },
    ];

    let handleClickXYZ = () => {
        setXYZ(!xyz)
        multiTileHuntLayersXYZ(props.mapReference)
        if (xyz) {
            props.mapReference.overlayMapTypes.clear();
        }
    }


    let handleDoubleLayer = () => {
        setXYZDouble(!xYZDouble)
        multiTileHuntLayersXYZTwoLayers(props.mapReference)
        if (xYZDouble) {
            props.mapReference.overlayMapTypes.clear();
        }
    }

    return (
        <div className='top-menu-container'>

            <div className='top-menu-tab-container'>
                <MakeATabView
                    key={'map'}
                    tabWidth="120px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    properties={{ tab: 'map', label: 'Map' }}
                    disable={false}
                />
            </div>


            <div className='top-menu-tab-container'>
                <MakeATabView
                    key='huntplanner'
                    properties={{ tab: 'huntplanner', label: 'Hunt Planner' }}
                    tabWidth="120px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    disable={props.isHuntPlannerDisable}
                />
            </div>

            <div className='top-menu-tab-container'>
                <MakeATabView
                    key={'recreationAccess'}
                    properties={{ tab: 'recreationAccess', label: 'Private Land Access' }}
                    tabWidth="170px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    disable={false}
                />
            </div>

            {/* {process.env.NODE_ENV != 'production' &&
                <>
                    <div style={{ position: 'fixed', top: '29%', right: '-5px', margin: 0 }} className="button-container-style">
                        <ReusableButton
                            buttonName='Hello'
                            className={`lets-go-button-label  ${!xyz ? 'text-color-white' : 'text-color-black'}`}
                            buttonColor={!xyz ? "#589500" : '#ffffff'}
                            label={'XYZ Layer'}
                            onClick={handleClickXYZ}
                            variant="primary"
                            size="small"
                            buttonWidth='100px'
                            buttonHeight="38px"
                        />
                    </div>

                    <div style={{ position: 'fixed', top: '35%', right: '-5px', margin: 0 }} className="button-container-style">
                        <ReusableButton
                            buttonName='Hello'
                            className={`lets-go-button-label  ${!xYZDouble ? 'text-color-white' : 'text-color-black'}`}
                            buttonColor={!xYZDouble ? "#589500" : '#ffffff'}
                            label={'Double Layer'}
                            onClick={handleDoubleLayer}
                            variant="primary"
                            size="small"
                            buttonWidth='100px'
                            buttonHeight="38px"
                        />
                    </div>
                </>
            } */}
        </div>
    );
};



const mapStateToProps = state => ({
    selectedTabvalue: state.selectedTab,
    isHuntPlannerDisable: state.isHuntPlannerDisable,
    mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
})

const mapDispatchToProps = dispatch => ({
    selectedTabAction: (payload) => dispatch(selectedTabAction(payload)),
    expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
    huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide())
})


// export default TopMenu;
export default connect(mapStateToProps, mapDispatchToProps)(TopMenu)


